import ArcIconButton from './ArcIconButton.js';
customElements.define(ArcIconButton.tag, ArcIconButton);
